import type { PaletteOptions } from '@mui/material/styles';

// Placeholder palette — green tones (Islamic context). Replace with brand tokens later.
// Both light and dark modes verified per agents/protocols/ui.md quality gate.

// Sage + cream — matches the landing-page design (D:\...\landing-design\sahib\project\app.jsx default tweaks).
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#6B8E6F',
    light: '#9CB89F',
    dark: '#4D6B50',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#0277BD',
    light: '#58A5F0',
    dark: '#004C8C',
    contrastText: '#FFFFFF',
  },
  // Brand "danger" terracotta — used for destructive actions (delete account,
  // delete chats, revoke), unverified-state chips, and the warning tone in
  // status pills. Defined here so every consumer reads `error.main` instead of
  // pasting the hex.
  error: {
    main: '#C77B5C',
    light: '#D9A088',
    dark: '#A55F42',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#FAFAF7',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1A1A1A',
    secondary: 'rgba(0, 0, 0, 0.6)',
  },
  divider: 'rgba(0, 0, 0, 0.08)',
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#66BB6A',
    light: '#98EE99',
    dark: '#338A3E',
    contrastText: '#000000',
  },
  secondary: {
    main: '#4FC3F7',
    light: '#8BF6FF',
    dark: '#0093C4',
    contrastText: '#000000',
  },
  error: {
    main: '#D8956E',
    light: '#E8B395',
    dark: '#B57252',
    contrastText: '#000000',
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#B0B0B0',
  },
  divider: 'rgba(255,255,255,0.12)',
};
